import '../../App.css';
import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";

interface Props {
  message: string,
}

function InfoAlert(props: Props) {
  return (
      <div className={"alert alert-secondary p-2 left-align"}>
        <FontAwesomeIcon className={"me-1 font-md"} icon={faInfoCircle}/>{props.message}
      </div>
  )
}

export default InfoAlert;